<!--
 * @Description: 选择申请机构弹框组件
 * @Author: gaohc
 * @Date: 2023-10-18 16:43:52
 * @LastEditTime: 2023-10-30 15:27:07
-->
<template>
  <div class="sel-inst-body">
    <el-dialog width="556px" title="选择申请机构" :visible.sync="visible" :close-on-click-modal="false"
      @open="initData" :before-close="handleCancel" center>
      <el-form :rules="rules" :model="ruleForm" ref="ruleForm" :label-position="labelPosition">
        <el-form-item label="申请机构：" prop="institutionId" required style="margin-bottom: 40px; padding-top: 24px;">
          <el-select size="small" filterable  v-model="ruleForm.institutionId" clearable placeholder="请输入/选择" 
            :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
				  	@visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)" 
            style="width: 240px;">
            <el-option v-for="item in institutionList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
export default {
  name: 'SelApplyInstDialog',
  props: ['visible'],

  data() {
    return {
      rules: {
        institutionId: [
          { required: true, message: '请选择申请机构', trigger: 'change' }
        ],
      },
      ruleForm: {
        institutionId: ''
      },
      labelPosition: 'left',
      institutionList: [],
      srcInstitutionList: [],
    }
  },
  
  methods: {
    initData() {
      this.appAxios("GET", Constant.URL_LIST_SIMPLE_INSTS_OF_NO_OPEN_MEMBER).then(result => {
        if (result == null) {
          return;
        }
        this.institutionList = result.data;
      	this.srcInstitutionList = result.data;
      })
    },

    //取消
    handleCancel() {
      this.clearVaild();
      this.$emit('close-dialog', {refresh: false});
    },

    //确定
    handleSubmit(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (!valid) return;
        let result = this.institutionList.find(item => item.id == this.ruleForm.institutionId);
        this.$emit("close-dialog", {refresh: true, instItem: result});
        this.clearVaild();
      });
    },

    clearVaild() {
      this.ruleForm = {};
    	this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
		},
  },
}
</script>

<style scoped>
.sel-inst-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.sel-inst-body .el-form-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.dialog-footer {
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/memmng/components/SelApplyInstDlg.vue